// @ts-nocheck

// components/atoms/Tabs/index.tsx
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import styles from './tabs.module.css';

export interface TabItem {
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

export interface AtomTabsProps {
  tabs: TabItem[];
  defaultTab?: number;
  onChange?: (index: number, tab: TabItem) => void;
  orientation?: 'horizontal' | 'vertical';
  variant?: 'standard' | 'fullWidth' | 'scrollable';
  indicatorColor?: 'primary' | 'secondary';
  textColor?: 'primary' | 'secondary' | 'inherit';
  centered?: boolean;
  className?: string;
  tabClassName?: string;
  children?: React.ReactNode;
  activeTabClassName?: string;
}

const AtomTabs: React.FC<AtomTabsProps> = ({
  tabs,
  defaultTab = 0,
  onChange,
  orientation = 'horizontal',
  variant = 'standard',
  indicatorColor = '',
  textColor = 'primary',
  centered = false,
  className,
  tabClassName,
  children,
  activeTabClassName,
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    if (onChange) {
      onChange(newValue, tabs[newValue]);
    }
  };

  // Function to get content for the active tab
  const getTabContent = (index: number) => {
    if (!children) return null;

    if (Array.isArray(children)) {
      return children[index];
    } else if (index === 0) {
      return children;
    }

    return null;
  };

  return (
    <div className={`${styles.tabsRoot} ${className || ''}`}>
      <MuiTabs
        value={activeTab}
        onChange={handleChange}
        orientation={orientation}
        variant={variant}
        indicatorColor={indicatorColor}
        textColor={textColor}
        centered={centered}
        className={styles.tabsContainer}
      >
        {tabs.map((tab, index) => (
          <MuiTab
            key={index}
            label={tab.label}
            icon={tab.icon}
            iconPosition="start"
            disabled={tab.disabled}
            className={`${styles.tab} ${tabClassName || ''} ${activeTab === index ? `${styles.activeTab} ${activeTabClassName || ''}` : ''}`}
          />
        ))}
      </MuiTabs>

      <div className={styles.tabPanels}>
        {tabs.map((_, index) => (
          <div
            key={index}
            role="tabpanel"
            hidden={activeTab !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            className={styles.tabPanel}
          >
            {activeTab === index && <Box className={styles.tabContent}>{getTabContent(index)}</Box>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AtomTabs;
